import React, { useState, useRef, useEffect } from "react";
import apiHeroku from "../../services/apiHeroku";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faStop } from "@fortawesome/fontawesome-free-solid";
import { CAMINHO_FOTOS } from "../../config";
import Util from "../../classes/util";
import "./index.css";
import { CircularProgress } from "@material-ui/core";

export default function Search({ descricao, mobile }) {
  const inputRef = useRef(null);

  const [pesquisa, setPesquisa] = useState(descricao || "");
  const [loading, setLoading] = useState(false);
  const [produtos, setProdutos] = useState([]);

  const formatValor = (value) => {
    return parseInt(value || 0).toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
    });
  };

  const getSeachProds = async () => {
    setLoading(true);
    try {
      const produtosData = (
        await apiHeroku("/produtos/filter/arco-iris", {
          params: {
            descricao: pesquisa,
            itens_page: 50000000,
          },
        })
      ).data;

      if (!produtosData || produtosData.length <= 0) {
        setProdutos([]);
      } else {
        setProdutos(produtosData);
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const PRODSearch = (data) => {
    return (
      <Link
        className="containerPRODSearch"
        reloadDocument
        to={{
          pathname: `/detalhaProduto`,
          state: { produto: { ...data, quantidade: 1 } },
        }}
      >
        <img
          className="imgPRODSearch"
          src={CAMINHO_FOTOS + Util.completarProduto(data?.chave)}
          onError={(e) => {
            e.currentTarget.src = require("../../images/semimagem.png");
          }}
        />
        <span className="labelPRODSearch">{data?.descricao || "SEM NOME"}</span>
        <span className="pricePRODSearch">
          {data?.preco_venda ? formatValor(data?.preco_venda) : formatValor(0)}
        </span>
      </Link>
    );
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (inputRef.current.value === pesquisa) {
        if (pesquisa !== "" && pesquisa) getSeachProds();
      }
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, [pesquisa, inputRef]);

  return (
    <div
      className="containerpesquisaprod"
      style={mobile && { border: "none", flex: 1 }}
    >
      <input
        type="text"
        id="pesquisa"
        name="pesquisa"
        placeholder="pesquisar..."
        className="pesquisalistaproduto"
        ref={inputRef}
        style={
          mobile && {
            width: "100%",
            flex: 1,
          }
        }
        onChange={(e) => {
          //  this.setState({ pesquisa: e.currentTarget.value });
          setPesquisa(e.target?.value);
        }}
        value={pesquisa}
      />
      {!mobile && (
        <div className="contnome_icopesquisa">
          <i class="fas fa-search"></i>
          <span>Buscar</span>
        </div>
      )}
      {pesquisa.length > 0 && (
        <div className="containerResultSearch">
          {loading && (
            <div className="containerLoadingResult">
              <CircularProgress color="white" size={30} />
            </div>
          )}
          {!loading && produtos.length <= 0 && (
            <div className="containerNoResult">
              <h4>Nenhum produto encontrado!</h4>
              <FontAwesomeIcon color="red" icon={faBan} size={"3x"} />
            </div>
          )}
          {!loading &&
            produtos.length > 0 &&
            produtos.map((e) => <PRODSearch {...e} />)}
        </div>
      )}
    </div>
  );
}
